export const MaterialPolicy = {
  ANY: 'ANY',
  PLANNED_ONLY: 'PLANNED_ONLY',
};

export const MaterialPolicyLabels = [
  { label: 'Bármely alapanyag', value: MaterialPolicy.ANY },
  { label: 'Csak tervezett alapanyag', value: MaterialPolicy.PLANNED_ONLY },
];
